import { authenticatedFetch } from 'api/fetch';
import {
  CreditUnitsRequest,
  TransferEventUnitsRequest,
  TransferPractitionerUnitsRequest,
  TransferUnitsResponse,
} from 'api/httpEntities';

export const creditUnitsToPractitionerWallet = async ({
  practitionerWalletId,
  amount,
  comment,
  reference,
  organisationId,
}: CreditUnitsRequest): Promise<void> => {
  const { json } = await authenticatedFetch(
    `/api/v1/wallets/${practitionerWalletId}/credit-units`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount, comment, reference, organisationId }),
    },
  );

  await json();
};

export const removeUnitsFromPractitionerWallet = async ({
  practitionerWalletId,
  amount,
  comment,
  reference,
  organisationId,
}: CreditUnitsRequest): Promise<void> => {
  const { json } = await authenticatedFetch(
    `/api/v1/wallets/${practitionerWalletId}/remove-units`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount, comment, reference, organisationId }),
    },
  );

  await json();
};

export const transferPractitionerUnits = async ({
  organisationId,
  practitionerId,
  amount,
  comment,
  reference,
  transferDirection,
  emailStrategy,
}: TransferPractitionerUnitsRequest): Promise<TransferUnitsResponse> => {
  const { json } = await authenticatedFetch(
    `/api/v1/organisations/${organisationId}/practitioners/${practitionerId}/units`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        amount,
        comment,
        reference,
        transferDirection,
        emailStrategy,
      }),
    },
  );

  return json();
};

export const transferEventUnits = async ({
  eventId,
  amount,
  transferType,
}: TransferEventUnitsRequest): Promise<TransferUnitsResponse> => {
  const { json } = await authenticatedFetch(`/api/v1/events/${eventId}/units`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount, transferType }),
  });
  return json();
};
